// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--3OeXt"};